import { z } from 'zod'

export const reservationLoginSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
  lastName: z.string().min(1, 'Ce champ est requis'),
  pnr: z.string().min(1, 'Ce champ est requis'),
})

export const reservationLoginWithPasswordSchema = reservationLoginSchema
  .extend({
    password: z.string().min(1, 'Ce champ est requis'),
    passwordConfirmation: z.string().min(1, 'Ce champ est requis'),
  })
  .superRefine((value, ctx) => {
    if (value.password !== value.passwordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Les mots de passe ne correspondent pas',
        path: ['passwordConfirmation'],
      })
    }
  })

export type ReservationLoginSchema = z.infer<typeof reservationLoginSchema>
export type ReservationLoginWithPasswordSchema = z.infer<typeof reservationLoginWithPasswordSchema>
